import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import useQuery from '../hooks/useQuery';
import { RootState, useCheckCouponValidationMutation, useGetReferralNameByCodeQuery } from '../store';
import { setCoupon } from '../store/slices/orders';
import useIsBackoffice from '../hooks/useIsBackoffice';

const CouponHeadsUp = () => {
  const location = useLocation();
  const isBackoffice = useIsBackoffice();
  const query = useQuery();
  const dispatch = useDispatch();

  // Early return if in backoffice
  if (isBackoffice) {
    return null;
  }

  const showCouponSubheader = location.pathname.includes('/events/');
  const couponCode = query.get('coupon');
  const referralCode = query.get('ref');
  const event = useSelector((state: RootState) => state.events.selectedEvent);
  const { coupon } = useSelector((state: RootState) => state.orders);

  const [checkCouponValidation, couponValidationResults] = useCheckCouponValidationMutation();

  const validateCoupon = (codeVal: string) => {
    checkCouponValidation({
      businessId: event?.business_id || '',
      eventId: event?.id || '',
      amount: 0,
      couponCode: codeVal,
    });
  };

  useEffect(() => {
    if (couponCode && !coupon && event?.id) {
      validateCoupon(couponCode);
    }
  }, [couponCode, event?.id]);

  useEffect(() => {
    if (couponValidationResults.data?.data) {
      localStorage.setItem(`${event?.id}_coupon`, JSON.stringify(couponValidationResults.data.data));
      dispatch(setCoupon(couponValidationResults.data.data));
    }
  }, [couponValidationResults.data]);

  useEffect(() => {
    if (event?.id && referralCode) {
      try {
        localStorage.setItem(`${event.id}_referral`, referralCode);
      } catch (e) {
        // ignore storage errors
      }
    }
  }, [event?.id, referralCode]);

  const storedReferralCode = event?.id ? localStorage.getItem(`${event.id}_referral`) : null;
  const activeReferralCode = referralCode || storedReferralCode;

  const { data: referralName } = useGetReferralNameByCodeQuery(
    {
      code: activeReferralCode || '',
      eventId: event?.id || '',
    },
    { skip: !activeReferralCode || !event },
  );

  const discount = (coupon?.coupon?.value ?? 0) * 100;
  const hasCoupon = couponCode && coupon;
  const hasReferral = !!activeReferralCode;

  if (!showCouponSubheader || (!hasCoupon && !hasReferral) || !event) {
    return null;
  }

  return (
    <div className='fixed top-[74px] left-0 right-0 z-10 mx-[-20px]'>
      {hasCoupon && (
        <div className='bg-primary-500 text-white text-center py-2'>
          DESCUENTO DEL {discount}% APLICADO
        </div>
      )}
      {hasReferral && (
        <div className='bg-primary-500 text-white text-center py-2'>
          {referralName ? `REFERIDO: ${referralName.toUpperCase()}` : 'CÓDIGO DE REFERIDO APLICADO'}
        </div>
      )}
    </div>
  );
};

export default CouponHeadsUp;
